import React, { useEffect, useState } from "react";
import { Document, Page } from "react-pdf";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, message, Upload } from "antd";
import { API_URL } from "../../../helper/axioscontants";
import "./CandidateProfilePreview.scss";

import { pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import { useParams } from "react-router-dom";
import FooterNuJobs from "../../../landing/footerNuJobs";
import NuJobsSignedInFooter from "../nuJobsSignedInFooter";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function NuJobsCandidateProfilePreview({  }) {
  const [numPages, setNumPages] = useState(null);
  const { myResumes} = useNuJobDetailsStore();
  const rid = useParams().resumeID;
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const [scale, setScale] = useState(1);
  const baseURL = API_URL;
  const userDetails = JSON.parse(localStorage.getItem("nujobsUserDetails"));
  const props = {
    accept: "pdf",
    showUploadList: true,
    method: "PUT",
    action: `${baseURL}/updateresume/${userDetails.nujoid}/${userDetails.nujuid}/${rid}`,
    name: "pdf",
    headers: {
      authorization: "authorization-text",
    },
    onChange(info) {
      const { status } = info.file;

      if (status === "done") {
        message.success(`${info.file.name} uploaded successfully`);

        //getProfileResumeDetails(jdID, selectedProfileResume.qhrid);
      } else if (status === "error") {
        message.error(`${info.file.name} upload failed.`);
      }
    },
  };
  function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    }   

  return (
    <div className="nujobscandidate-resume-preview-container">
      <div className="nujobscandidate-resume-preview-title">
        <div className="candidate-resume-preview-left">
          <h2>Resume - {myResumes?.[rid]?.resumename}</h2>
          <p>
            Updated On: {formatUnixDate(myResumes?.[rid]?.myresume?.timestamp)}
          </p>
        </div>
      </div>
      <div className="candidate-resume-preview-download">
        <a
          href={`data:application/pdf;base64,${myResumes?.[rid]?.myresume}`}
          download={`[${rid}]-${
            myResumes?.[rid]?.myresume?.personaldetail.name
          }-Resume-${new Date().toLocaleDateString()}.pdf`}
            style={{
              padding: "8px 12px",
              background: "#007bff",
              color: "#fff",
              borderRadius: 4,
              textDecoration: "none",
            }}
          >
            Download <DownloadOutlined />
          </a>
          <Upload {...props}>
            <Button
              style={{ marginLeft: "10px", height: "35px" }}
              icon={<UploadOutlined />}
            >
              Update
            </Button>
          </Upload>
      </div>
      <div className="candidate-resume-preview-wrapper-container">
        <div className="candidate-resume-preview-wrapper">
          <Document
            file={`data:application/pdf;base64,${myResumes?.[rid]?.myresume?.resume}`}
            onLoadSuccess={onDocumentLoadSuccess}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                scale={scale}
              />
            ))}
          </Document>
        </div>
      </div>
      <div className="nujobs-footer">
        <NuJobsSignedInFooter />
      </div>
    </div>
  );
}

export default NuJobsCandidateProfilePreview;
